import React from 'react';

/** Reads the line and node conventions of NetworkDiagram. Reuses the metadata legend classes. */
const NetworkLegend = ({ layout, rejectedHidden = 0 }) => {
  const omitted = Object.values((layout && layout.omitted) || {}).reduce((s, n) => s + n, 0);
  return (
    <div className='metadata-legend' data-testid='sfn-legend'>
      <span className='metadata-legend-label'>Links</span>
      <span className='metadata-legend-row'><span className='sfn-legend-line' /> lookup</span>
      <span className='metadata-legend-row'><span className='sfn-legend-line sfn-legend-line--master_detail' /> master-detail</span>
      <span className='metadata-legend-row'><span className='sfn-legend-line sfn-legend-line--manual' /> manual link</span>
      <span className='metadata-legend-label'>Objects</span>
      <span className='metadata-legend-row'>
        <span className='sfn-legend-dot' /><span className='sfn-legend-dot sfn-legend-dot--big' /> size = records
      </span>
      <span className='metadata-legend-row'>arrow points at the object being referenced</span>
      {rejectedHidden > 0 && <span className='metadata-legend-row'>{rejectedHidden} rejected hidden</span>}
      {omitted > 0 && <span className='metadata-legend-row'>+{omitted} omitted from crowded rings</span>}
    </div>
  );
};

export default NetworkLegend;
